<!-- =========================================================================================
    File Name: AgGridTable.vue
    Description: Ag Grid table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="ag-grid-demo">
    <vx-card>

      <!-- TABLE ACTION ROW -->
      <div class="flex flex-wrap justify-between items-center">

        <!-- ITEMS PER PAGE -->
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ consultationsList.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : consultationsList.length }} of {{ consultationsList.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                <span>150</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Buscar..." />
          <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
        </div>
      </div>
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="consultationsList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="currentPage" />

    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
// import contacts from './data.json'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

// cell renderer
import CellRendererPatient from './cell-renderer/CellRendererPatient.vue';

export default {
  components: {
    AgGridVue,
    CellRendererPatient
  },
  data () {
    return {
      searchQuery: '',
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          filter: false,
          sortable: true,
          resizable: false,
          filter: 'agNumberColumnFilter',
          width: 80
        },
       {
            headerName: 'Paciente',
            valueGetter: function(params) {
                return params.data.patient.first_name+' '+params.data.patient.last_name; 
            },
            getQuickFilterText: function(params) {
                return params.data.patient.first_name+' '+params.data.patient.last_name; 
            },
            sortable: true,
            filter: 'agTextColumnFilter',
            width: 140
        },
        {
            headerName: 'Correo',
            valueGetter: function(params) {
                return params.data.patient.email; 
            },
            getQuickFilterText: function(params) {
                return params.data.patient.email;
            },
            sortable: true,
            filter: 'agTextColumnFilter',
            width: 140
        },
        {
            headerName: 'Tipo',
            valueGetter: function(params) {
                return params.data.type == 'consultation' ? 'Consulta' : 'Virtual' 
            },
            getQuickFilterText: function(params) {
                return params.data.type == 'consultation' ? 'Consulta' : 'Virtual'
            },
            sortable: true,
            filter: 'agTextColumnFilter',
            width: 120
        },
        {
            headerName: 'Clínica',
            valueGetter: function(params) {
                return params.data.clinic.title 
            },
            getQuickFilterText: function(params) {
                return params.data.clinic.title
            },
            sortable: true,
            filter: 'agTextColumnFilter',
            width: 140
        },
        {
            headerName: 'Fecha',
            valueGetter: function(params) {
                var dateStringOptions =  { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
                return new Date(params.data.date).toLocaleDateString('es-ES', dateStringOptions)
            },
            getQuickFilterText: function(params) {
                var dateStringOptions =  { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
                return new Date(params.data.date).toLocaleDateString('es-ES', dateStringOptions)
            },
            sortable: true,
            filter: 'agTextColumnFilter',
            width: 140
        },
        {
            headerName: 'Horario',
            valueGetter: function(params) {
              var timeStringOptions =  { hour: 'numeric', minute: 'numeric', hour12: true };
              var tempObj = {}
              tempObj.startStr = params.data.date;
              
              if(params.data.duration){
                var sTime = new Date(params.data.date);
                sTime.setMinutes(sTime.getMinutes() + params.data.duration);
                tempObj.endStr =  sTime;
              }
              return `${new Date(tempObj.startStr).toLocaleTimeString('en-EN', timeStringOptions)} - 
                    ${new Date(tempObj.endStr).toLocaleTimeString('en-EN', timeStringOptions)}
                  `
            },
            getQuickFilterText: function(params) {
              var timeStringOptions =  { hour: 'numeric', minute: 'numeric', hour12: true };
              var tempObj = {}
              tempObj.startStr = params.data.date;
              
              if(params.data.duration){
                var sTime = new Date(params.data.date);
                sTime.setMinutes(sTime.getMinutes() + params.data.duration);
                tempObj.endStr =  sTime;
              }
              return `${new Date(tempObj.startStr).toLocaleTimeString('en-EN', timeStringOptions)} - 
                    ${new Date(tempObj.endStr).toLocaleTimeString('en-EN', timeStringOptions)}
                  `
            },
            sortable: true,
            filter: 'agTextColumnFilter',
            width: 140
        },
        {
            headerName: 'Duración',
            valueGetter: function(params) {
              
              return ` ${params.data.duration} minutos`
            },
            getQuickFilterText: function(params) {
                return params.data.duration
            },
            sortable: true,
            filter: 'agTextColumnFilter',
            width: 140
        },
        {
            headerName: 'Total',
            valueGetter: function(params) {
              return `Q ${parseFloat(params.data.meta.consultationTotal).toFixed(2)}`
            },
            getQuickFilterText: function(params) {
                return  parseFloat(params.data.meta.consultationTotal).toFixed(2);
            },
            sortable: true,
            filter: 'agTextColumnFilter',
            width: 140
        },
        // {
        //   headerName: 'Followers',
        //   field: 'followers',
        //   filter: 'agNumberColumnFilter',
        //   width: 125
        // }
      ],
      components: {
        CellRendererPatient,
      }
    }
  },
  watch: {
    '$store.state.windowWidth' (val) {
      if (val <= 576) {
        this.maxPageNumbers = 4
        this.gridOptions.columnApi.setColumnPinned('email', null)
      } 
      else this.gridOptions.columnApi.setColumnPinned('email', 'left')
    }
  },
  computed: {
    consultationsList (){
      // return this.$store.state.consultations
      let activeConsultations = this.$store.state.consultations.filter(obj => {
        return ( obj.meta.status && obj.meta.status.toLowerCase() == 'terminada' )
          || ( obj.meta.status && obj.meta.status.toLowerCase() == 'anulada' );
      });
      activeConsultations.sort(function compare(a, b) {
        var dateA = new Date(a.date);
        var dateB = new Date(b.date);
        return dateA - dateB;
      });
      // descendiente
      console.log(activeConsultations.reverse());
      return activeConsultations.reverse();
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 50
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    this.$store.dispatch('fetchEvents');

    

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  }
}

</script>
